import { Home, FolderOpen, Users, Bell, UserCircle } from "lucide-react";

export default function MobileBottomNav({ activeItem, onNavigate, notificationCount = 0 }) {
  const items = [
    { id: "home", label: "Accueil", icon: Home, hub: null, item: null },
    { id: "dossiers", label: "Dossiers", icon: FolderOpen, hub: "metier", item: "dossiers" },
    { id: "clients", label: "Clients", icon: Users, hub: "metier", item: "clients" },
    { id: "notifications", label: "Notifs", icon: Bell, hub: null, item: "notifications" },
    { id: "profile", label: "Profil", icon: UserCircle, hub: null, item: "profile" },
  ];

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-50 bg-[var(--oh-bg-surface)] backdrop-blur-lg border-t border-[var(--oh-border)] lg:hidden safe-area-bottom"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-1">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = activeItem === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item)}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors relative ${
                isActive 
                  ? "text-[var(--oh-accent-text)]" 
                  : "text-[var(--oh-text-muted)] active:text-[var(--oh-text-secondary)]"
              }`}
              data-testid={`mobile-nav-${item.id}`}
            >
              <div className="relative">
                <Icon className={`w-5 h-5 ${isActive ? "stroke-[2.5]" : ""}`} />
                {item.id === "notifications" && notificationCount > 0 && (
                  <span className="absolute -top-1 -right-2 bg-red-500 text-[var(--oh-accent-contrast)] text-[10px] font-medium rounded-full w-4 h-4 flex items-center justify-center">
                    {notificationCount > 9 ? "9+" : notificationCount}
                  </span>
                )}
              </div>
              <span className={`text-[10px] leading-tight ${isActive ? "font-medium" : ""}`}>
                {item.label}
              </span>
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[var(--oh-accent-solid)] rounded-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
